<template>
	<section
		:style="{
			height: hasAccess()
				? 'height: calc(100vh - 148px);'
				: 'height: calc(100vh - 168px);',
		}"
		style="
			width: 100%;
			height: calc(100vh - 148px);
			overflow-x: hidden;

			background: #ffffff;
			border-radius: 8px;
		"
	>
		<div class="d-flex align-items-center">
			<div
				class="fw-B fs-18 text-darkgrey fam-lato mb-2"
				style="padding: 10px 5px 0 15px"
			>
				Filters
			</div>
			<div
				v-if="totalFilterCount > 0"
				class="filters-count-tag fs-12 fw-M text-blue fam-lato d-flex align-items-center justify-content-center"
			>
				{{ totalFilterCount }}
			</div>
		</div>
		<section
			:style="{
				height: hasAccess() ? 'calc(100vh - 280px)' : 'calc(100vh - 300px)',
				overflowY: 'auto',
				overflowX: 'hidden',
				padding: '10px 15px',
			}"
		>
			<!-- Sort By -->
			<div class="filter-card">
				<div class="filter-header" @click="sortByOpen = !sortByOpen">
					<span>Sort by</span>
					<span>
						<span v-if="sectionCounts.sortBy" class="mr-2">{{
							sectionCounts.sortBy
						}}</span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: sortByOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="sortByOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-radio-group v-model="selectedSortBy" name="sortBy" stacked>
							<b-form-radio
								v-for="(label, key) in SORT_BY"
								:key="key"
								:value="key"
								class="filter-text-alltags mb-1"
							>
								{{ label }}
							</b-form-radio>
						</b-form-radio-group>
					</div>
				</b-collapse>
			</div>

			<!-- Practice -->
			<div class="filter-card">
				<div class="filter-header" @click="practiceOpen = !practiceOpen">
					<span>Practice</span>
					<span>
						<span v-if="sectionCounts.practice" class="mr-2">{{
							sectionCounts.practice
						}}</span
						><img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: practiceOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="practiceOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-checkbox-group v-model="selectedPractice" stacked>
							<b-form-checkbox value="assessments" class="mb-2">
								Assessments
							</b-form-checkbox>

							<b-form-checkbox value="sandbox" class="mb-2">
								Projects
							</b-form-checkbox>
							<b-form-checkbox value="leaderboard">
								Leaderboard Assessments
							</b-form-checkbox>
						</b-form-checkbox-group>
					</div>
				</b-collapse>
			</div>

			<!-- Levels -->
			<div class="filter-card candash-checkbox-parent">
				<div class="filter-header" @click="levelsOpen = !levelsOpen">
					<span>Levels</span>
					<span>
						<span v-if="sectionCounts.levels" class="mr-2">{{
							sectionCounts.levels
						}}</span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: levelsOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="levelsOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-checkbox-group v-model="selectedLevels" stacked>
							<b-form-checkbox v-for="n in 5" :key="n" :value="n" class="mb-2">
								Level {{ n }}
							</b-form-checkbox>
						</b-form-checkbox-group>
					</div>
				</b-collapse>
			</div>

			<!-- Duration -->
			<div class="filter-card">
				<div class="filter-header" @click="durationOpen = !durationOpen">
					<span>Duration</span>
					<span>
						<span v-if="sectionCounts.duration" class="mr-2">1</span
						><img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: durationOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="durationOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-radio-group v-model="selectedDuration" stacked>
							<b-form-radio value="0-30" class="mb-2">0-30 mins</b-form-radio>
							<b-form-radio value="31-60" class="mb-2">31-60 mins</b-form-radio>
							<b-form-radio value="61-90" class="mb-2">61-90 mins</b-form-radio>
							<b-form-radio value="90+">90+ more mins</b-form-radio>
						</b-form-radio-group>
					</div>
				</b-collapse>
			</div>

			<!-- Price -->
			<div class="filter-card">
				<div class="filter-header" @click="priceOpen = !priceOpen">
					<span>Price</span>
					<span>
						<span v-if="sectionCounts.price" class="mr-2">1 </span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: priceOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="priceOpen">
					<div class="filter-body">
						<vue-slider
							v-model="priceRange"
							:min="0"
							:max="maxPricerange"
							:enable-cross="false"
							:tooltip="'none'"
						/>
						<div
							class="d-flex align-items-center justify-content-between priceinputs"
						>
							<div cla>
								<label class="price-input-label mb-0">Minimum</label>
								<div class="position-relative">
									<span
										class="position-absolute"
										style="
											left: 10px;
											top: 50%;
											transform: translateY(-50%);
											color: #667085;
											z-index: 2;
											pointer-events: none;
										"
										>₹</span
									>
									<b-form-input
										type="number"
										v-model="minInput"
										@input="validatePriceInputs"
										:class="{ 'error-border': minErrorMsg }"
										style="
											padding-left: 22px;
											font-size: 14px;
											padding-right: 5px;
										"
									></b-form-input>
									<img
										v-if="minErrorMsg"
										src="@/assets/img/pinfo.svg"
										class="position-absolute pointer"
										style="
											right: 8px;
											top: -10px;
											transform: translateY(-50%);
											z-index: 2;
											width: 14px;
										"
										v-b-tooltip.hover
										:title="minErrorMsg"
									/>
								</div>
							</div>
							<div>
								<label class="price-input-label mb-0">Maximum</label>
								<div class="position-relative">
									<span
										class="position-absolute"
										style="
											left: 10px;
											top: 50%;
											transform: translateY(-50%);
											color: #667085;
											z-index: 2;
											pointer-events: none;
										"
										>₹</span
									>
									<b-form-input
										type="number"
										v-model="maxInput"
										@input="validatePriceInputs"
										:class="{ 'error-border': maxErrorMsg }"
										style="
											padding-left: 22px;
											font-size: 14px;
											padding-right: 5px;
										"
									></b-form-input>
									<img
										v-if="maxErrorMsg"
										src="@/assets/img/pinfo.svg"
										class="position-absolute pointer"
										style="
											right: 8px;
											top: -10px;
											transform: translateY(-50%);
											z-index: 2;
											width: 14px;
										"
										v-b-tooltip.hover
										:title="maxErrorMsg"
									/>
								</div>
							</div>
						</div>
					</div>
				</b-collapse>
			</div>

			<!-- Topic Name -->

			<div class="filter-card">
				<div class="filter-header" @click="topicOpen = !topicOpen">
					<span>Topic Name</span>
					<span>
						<span v-if="sectionCounts.topic" class="mr-2">{{
							sectionCounts.topic
						}}</span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: topicOpen }"
						/>
					</span>
				</div>
				<b-collapse v-model="topicOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-checkbox-group v-model="selectedTopic" stacked>
							<b-form-checkbox
								class="mb-2"
								v-for="(topic, i) in visibleTopics"
								:key="i"
								:value="topic"
							>
								{{ topic }}
							</b-form-checkbox>
						</b-form-checkbox-group>

						<div
							class="pointer filter-header fw-B fs-14 fam-lato color-344054"
							@click="loadMoreTopics()"
						>
							<span v-if="topicsVisibleCount < topics.flat().length">
								Show more<img
									class="ml-1 rotate"
									src="@/assets/assessment/filteruparw.svg"
								/>
							</span>
							<span v-else @click.stop="topicsVisibleCount = 5">
								Show less<img
									class="ml-1"
									src="@/assets/assessment/filteruparw.svg"
								/>
							</span>
						</div>
					</div>
				</b-collapse>
			</div>

			<!-- Category -->
			<div class="filter-card">
				<div class="filter-header" @click="categoryOpen = !categoryOpen">
					<span>Category</span>
					<span>
						<span v-if="sectionCounts.category" class="mr-2">{{
							sectionCounts.category
						}}</span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: categoryOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="categoryOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-checkbox-group v-model="selectedCategory" stacked>
							<b-form-checkbox
								v-for="cat in categories"
								:key="cat.categoryID"
								:value="cat.categoryID"
								class="mb-2"
							>
								{{ cat.categoryTitle }}
							</b-form-checkbox>
						</b-form-checkbox-group>
					</div>
				</b-collapse>
			</div>

			<!-- Sub Category -->
			<div class="filter-card">
				<div class="filter-header" @click="subCategoryOpen = !subCategoryOpen">
					<span>Sub-Category</span>
					<span>
						<span v-if="sectionCounts.subCategory" class="mr-2">{{
							sectionCounts.subCategory
						}}</span>
						<img
							src="@/assets/assessment/filteruparw.svg"
							:class="{ rotate: subCategoryOpen }"
						/>
					</span>
				</div>

				<b-collapse v-model="subCategoryOpen">
					<div class="filter-body candash-checkbox-parent">
						<b-form-checkbox-group v-model="selectedSubCategory" stacked>
							<b-form-checkbox
								v-for="sub in allSubCategories"
								:key="sub.subCategoryID"
								:value="sub.subCategoryID"
								class="mb-2"
							>
								{{ sub.subCategoryTitle }}
							</b-form-checkbox>
						</b-form-checkbox-group>
					</div>
				</b-collapse>
			</div>
		</section>
		<div
			class="candash-modal-footer d-flex align-items-center justify-content-between mt-4"
		>
			<b-button
				class="candash-cancelBtn mr-4 pointer"
				@click="clearFilters()"
				:disabled="!isAnyFilterApplied"
				>Clear
			</b-button>
			<b-button
				class="candash-addBtn pointer"
				:disabled="!isAnyFilterApplied"
				@click="applyFilters(true)"
				>Apply</b-button
			>
		</div>
	</section>
</template>

<script>
import { hasAccess } from "@/utils/tokenCheck";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { getCategories, getSubCategories } from "@/utils/apiFunctions";
const SORT_BY = {
	intDifficulty_true: "Levels(Asc)",
	intDifficulty_false: "Levels(Desc)",
	testDuration_true: "Duration(Asc)",
	testDuration_false: "Duration(Desc)",
	topicName_true: "Topics(Asc)",
	topicName_false: "Topics(Desc)",
	testName_true: "Tests(Asc)",
	testName_false: "Tests(Desc)",
};

export default {
	name: "AssessmentFilter",
	components: {
		VueSlider,
	},
	data() {
		return {
			minInput: 0,
			maxInput: 0,
			minErrorMsg: "",
			maxErrorMsg: "",
			isUpdatingFromInput: false,
			SORT_BY,
			sortByOpen: true,
			practiceOpen: true,
			levelsOpen: true,
			durationOpen: true,
			priceOpen: true,
			topicOpen: true,
			categoryOpen: true,
			subCategoryOpen: true,

			selectedSortBy: null,
			selectedPractice: [],
			selectedLevels: [],
			selectedDuration: null,
			priceRange: [0, this.maxPricerange],
			selectedTopic: [],
			showAllTopics: false,
			selectedCategory: [],
			selectedSubCategory: [],

			categories: [],
			subCategories: {},
			topicsVisibleCount: 5,
			appliedState: {
				practice: [],
				levels: [],
				duration: null,
				topic: [],
				category: [],
				subCategory: [],
				priceRange: [],
				sortBy: null,
			},
		};
	},
	props: {
		topics: {
			type: Array,
			default: () => [],
		},
		maxPricerange: {
			type: Number,
			default: 0,
		},
		appliedFilters: {
			type: Object,
			default: null,
		},
	},
	// mounted() {
	// 	this.priceRange = [0, this.maxPricerange];
	// },
	computed: {
		sectionCounts() {
			const s = this.appliedState;

			return {
				practice: s.practice.length,
				levels: s.levels.length,
				duration: s.duration ? 1 : 0,
				topic: s.topic.length,
				category: s.category.length,
				subCategory: s.subCategory.length,
				price:
					s.priceRange.length === 2 &&
					(s.priceRange[0] !== 0 || s.priceRange[1] !== this.maxPricerange)
						? 1
						: 0,
				sortBy: s.sortBy ? 1 : 0,
			};
		},
		visibleTopics() {
			const flatTopics = this.topics.flat();
			return flatTopics.slice(0, this.topicsVisibleCount);
		},
		allSubCategories() {
			// if no category selected → show ALL
			if (!this.selectedCategory.length) {
				return Object.values(this.subCategories).flat();
			}

			// if category selected → filter only those
			return this.selectedCategory.flatMap(
				(catId) => this.subCategories[catId] || []
			);
		},
		totalFilterCount() {
			let count = 0;
			const s = this.appliedState;

			if (s.practice.length) count += 1;
			if (s.levels.length) count += 1;
			if (s.duration) count += 1;
			if (s.topic.length) count += 1;
			if (s.category.length) count += 1;
			if (s.subCategory.length) count += 1;

			if (
				s.priceRange.length === 2 &&
				(s.priceRange[0] !== 0 || s.priceRange[1] !== this.maxPricerange)
			) {
				count += 1;
			}

			if (s.sortBy) count += 1;

			return count;
		},
		isAnyFilterApplied() {
			const s = this.appliedState;

			const hasApplied =
				s.practice.length ||
				s.levels.length ||
				s.duration ||
				s.topic.length ||
				s.category.length ||
				s.subCategory.length ||
				(s.priceRange.length === 2 &&
					(s.priceRange[0] !== 0 || s.priceRange[1] !== this.maxPricerange)) ||
				s.sortBy;

			const hasSelected =
				this.selectedPractice.length ||
				this.selectedLevels.length ||
				this.selectedDuration ||
				this.selectedTopic.length ||
				this.selectedCategory.length ||
				this.selectedSubCategory.length ||
				(this.priceRange.length === 2 &&
					(this.priceRange[0] !== 0 ||
						this.priceRange[1] !== this.maxPricerange)) ||
				this.selectedSortBy;

			return hasApplied || hasSelected;
		},
	},
	created() {
		this.getCategoriesAndSubCategories();

		// Only the standalone instance (desktop, no appliedFilters prop) reads
		// and applies the URL filter. The modal instance is parent-controlled via
		// :appliedFilters, so it must NOT self-apply from the URL (that would
		// fire handleApplyFilters a second time).
		if (this.appliedFilters) return;

		const { practice, categoryIDs, subCategoryIDs } = this.$route.query;

		// Practice
		if (practice) {
			try {
				this.selectedPractice = JSON.parse(practice);
			} catch {
				this.selectedPractice = [practice];
			}
		}

		// Category from Explore page
		if (categoryIDs) {
			try {
				this.selectedCategory = JSON.parse(categoryIDs);
				this.appliedState.category = [...this.selectedCategory];
			} catch {
				this.selectedCategory = [categoryIDs];
				this.appliedState.category = [...this.selectedCategory];
			}
		}

		// SubCategory from company assessment tag
		if (subCategoryIDs) {
			try {
				this.selectedSubCategory = JSON.parse(subCategoryIDs);
				this.appliedState.subCategory = [...this.selectedSubCategory];
			} catch {
				this.selectedSubCategory = [subCategoryIDs];
				this.appliedState.subCategory = [...this.selectedSubCategory];
			}
		}

		// Apply the URL filter exactly ONCE, after all selections are set, so a
		// single @apply -> handleApplyFilters fires and the APIs run just one time.
		if (practice || categoryIDs || subCategoryIDs) {
			this.$nextTick(() => {
				this.applyFilters();
			});
		}
	},
	methods: {
		hasAccess() {
			return hasAccess();
		},
		validatePriceInputs() {
			this.isUpdatingFromInput = true;
			this.minErrorMsg = "";
			this.maxErrorMsg = "";

			let minStr = String(this.minInput).trim();
			let maxStr = String(this.maxInput).trim();
			let minNum = Number(minStr);
			let maxNum = Number(maxStr);
			let isValid = true;

			if (!minStr || minStr === "" || isNaN(minNum)) {
				this.minErrorMsg = "Cannot be empty.";
				isValid = false;
			} else if (minNum < 0) {
				this.minErrorMsg = "Cannot be negative.";
				isValid = false;
			}

			if (!maxStr || maxStr === "" || isNaN(maxNum)) {
				this.maxErrorMsg = "Cannot be empty.";
				isValid = false;
			} else if (maxNum < 0) {
				this.maxErrorMsg = "Cannot be negative.";
				isValid = false;
			}

			if (isValid && minNum > maxNum) {
				this.minErrorMsg = "Cannot exceed maximum price.";
				this.maxErrorMsg = "Cannot be less than minimum price.";
				isValid = false;
			}

			if (isValid && this.maxPricerange !== 0 && maxNum > this.maxPricerange) {
				this.maxErrorMsg = `Cannot exceed ${this.maxPricerange}.`;
				isValid = false;
			}

			if (isValid) {
				if (this.priceRange[0] !== minNum || this.priceRange[1] !== maxNum) {
					this.$set(this.priceRange, 0, minNum);
					this.$set(this.priceRange, 1, maxNum);
					this.priceRange = [...this.priceRange];
				}
			}

			this.$nextTick(() => {
				this.isUpdatingFromInput = false;
			});
		},
		loadMoreTopics() {
			const total = this.topics.flat().length;

			if (this.topicsVisibleCount < total) {
				this.topicsVisibleCount += 5;
			}
		},
		async getCategoriesAndSubCategories() {
			await this.getCategories();
		},
		async getCategories() {
			this.searchQuery = this.tempSearchQuery;
			this.categories = null;
			try {
				const res = await getCategories({ searchQuery: this.searchQuery });
				if (res.status === 200) {
					this.categories = res.data.data;
					await Promise.all(
						this.categories.map((cat) => this.getSubCategories(cat.categoryID))
					);
					const { categoryIDs, subCategoryIDs } = this.$route.query;

					// Only refresh the URL-driven selection on the standalone instance;
					// the modal instance is driven by :appliedFilters instead.
					if (!this.appliedFilters && categoryIDs) {
						try {
							this.selectedCategory = JSON.parse(categoryIDs);
						} catch {
							this.selectedCategory = [categoryIDs];
						}
					}

					if (!this.appliedFilters && subCategoryIDs) {
						try {
							this.selectedSubCategory = JSON.parse(subCategoryIDs);
						} catch {
							this.selectedSubCategory = [subCategoryIDs];
						}
					}
				}
			} catch (error) {
				console.log(error);
				this.categories = [];
			}
		},
		async getSubCategories(categoryID) {
			try {
				const res = await getSubCategories({
					categoryID,
					searchQuery: this.searchQuery,
				});

				if (res.status === 200) {
					this.$set(this.subCategories, categoryID, res.data.data);
				}
			} catch (error) {
				console.log(error);
				this.$set(this.subCategories, categoryID, []);
			}
		},
		applyFilters(isUserAction = false) {
			const filters = {};

			if (this.selectedSortBy) filters.sortBy = this.selectedSortBy;
			if (this.selectedPractice.length)
				filters.practice = this.selectedPractice;
			if (this.selectedLevels.length) filters.levels = this.selectedLevels;
			if (this.selectedDuration) filters.duration = this.selectedDuration;
			if (this.selectedTopic.length) filters.topic = [...this.selectedTopic];
			if (this.selectedCategory.length)
				filters.categoryIDs = [...this.selectedCategory];
			if (this.selectedSubCategory.length)
				filters.subCategoryIDs = [...this.selectedSubCategory];
			const isPriceChanged =
				this.priceRange &&
				(this.priceRange[0] !== 0 || this.priceRange[1] !== this.maxPricerange);
			if (isPriceChanged) {
				filters.priceFrom = this.priceRange[0];
				filters.priceTo = this.priceRange[1];
			}

			// FIRST update state

			this.appliedState = {
				practice: [...this.selectedPractice],
				levels: [...this.selectedLevels],
				duration: this.selectedDuration,
				topic: [...this.selectedTopic],
				category: [...this.selectedCategory],
				subCategory: [...this.selectedSubCategory],
				priceRange: isPriceChanged ? [...this.priceRange] : [],
				sortBy: this.selectedSortBy,
			};
			console.log(
				"DEBUG APPLIED STATE",
				this.appliedState,
				this.totalFilterCount
			);
			// THEN emit
			this.$emit("apply", filters, isUserAction, this.totalFilterCount);
			this.$emit("filter-count", this.totalFilterCount);
		},
		clearFilters() {
			const s = this.appliedState;
			const wasApplied =
				s.practice.length ||
				s.levels.length ||
				s.duration ||
				s.topic.length ||
				s.category.length ||
				s.subCategory.length ||
				s.sortBy ||
				(s.priceRange.length === 2 &&
					(s.priceRange[0] !== 0 || s.priceRange[1] !== this.maxPricerange));

			this.selectedSortBy = null;
			this.selectedPractice = [];
			this.selectedLevels = [];
			this.selectedDuration = null;
			this.priceRange = [0, this.maxPricerange];

			this.selectedTopic = [];
			this.selectedCategory = [];
			this.selectedSubCategory = [];

			this.appliedState = {
				practice: [],
				levels: [],
				duration: null,
				topic: [],
				category: [],
				subCategory: [],
				priceRange: [0, this.maxPricerange],
				sortBy: null,
			};
			this.$emit("clear", wasApplied);
		},
	},
	watch: {
		priceRange: {
			immediate: true,
			deep: true,
			handler(val) {
				if (val && val.length === 2) {
					if (!this.isUpdatingFromInput) {
						this.minInput = val[0];
						this.maxInput = val[1];
						this.minErrorMsg = "";
						this.maxErrorMsg = "";
					}
				}
			},
		},
		appliedFilters: {
			immediate: true,
			handler(val) {
				if (!val) return;

				this.selectedPractice = val.practice || [];
				this.selectedLevels = val.levels || [];
				this.selectedDuration = val.duration || null;
				this.selectedTopic = val.topic || [];
				this.selectedCategory = val.categoryIDs || [];
				this.selectedSubCategory = val.subCategoryIDs || [];
				this.selectedSortBy = val.sortBy || null;

				if (val.priceFrom !== undefined && val.priceTo !== undefined) {
					this.priceRange = [val.priceFrom, val.priceTo];
				} else {
					this.priceRange = [0, this.maxPricerange];
				}
				const isPriceChanged =
					this.priceRange &&
					(this.priceRange[0] !== 0 ||
						this.priceRange[1] !== this.maxPricerange);

				this.appliedState = {
					practice: [...this.selectedPractice],
					levels: [...this.selectedLevels],
					duration: this.selectedDuration,
					topic: [...this.selectedTopic],
					category: [...this.selectedCategory],
					subCategory: [...this.selectedSubCategory],
					priceRange: isPriceChanged ? [...this.priceRange] : [], // ✅ FIX
					sortBy: this.selectedSortBy,
				};
			},
		},
		maxPricerange(newVal) {
			// If user has NOT manually changed price
			const isDefault =
				this.priceRange[0] === 0 &&
				(this.priceRange[1] === 0 || this.priceRange[1] === this.maxPricerange);

			if (isDefault) {
				this.priceRange = [0, newVal];
			}
		},
		async selectedCategory(newVal = [], oldVal = []) {
			const oldList = oldVal || [];
			const newList = newVal || [];

			const added = newList.filter((id) => !oldList.includes(id));
			const removed = oldList.filter((id) => !newList.includes(id));

			// ADD: fetch subcategories
			for (const categoryID of added) {
				await this.getSubCategories(categoryID);
			}

			// REMOVE: subcategories + unselect them
			for (const categoryID of removed) {
				const removedSubs = this.subCategories[categoryID] || [];

				// remove selected subcategories belonging to this category
				const removedIds = removedSubs.map((sub) => sub.subCategoryID);

				this.selectedSubCategory = this.selectedSubCategory.filter(
					(id) => !removedIds.includes(id)
				);

				// remove from UI
				// this.$delete(this.subCategories, categoryID);
			}
		},
	},
};
</script>

<style scoped>
.error-border {
	border: 1px solid red !important;
}

.filter-card {
	border-bottom: 1px solid #eee;
	padding: 10px 0;
}

.filter-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	font-weight: 700;
	color: #344054;
	font-size: 14px;
	font-family: "Lato", sans-serif;
}

.filter-header img {
	transition: transform 0.25s ease;
}

.rotate {
	transform: rotate(180deg);
}

.filter-body {
	padding: 10px 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}
.filters-count-tag {
	width: 24px;
	height: 20px;
	background: rgba(32, 99, 155, 0.16);
	border-radius: 100px;
}
.filter-header span:second-child {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 12px;
	color: #5b5e71;
}
.candash-checkbox-parent .custom-control label {
	font-weight: 400 !important;
	font-family: "Lato", sans-serif !important;
	font-size: 14px !important;
	color: #344054 !important;
}
.price-input-label {
	color: #344054;
	font-size: 12px;
	font-family: "Lato", sans-serif;
	font-weight: 400;
}
.priceinputs .form-control {
	background: #ffffff;
	border: 1px solid #f1f1f1;
	border-radius: 4px;
	width: 80px;
}
.priceinputs .form-control:focus {
	box-shadow: unset;
}
</style>
